// extracted by mini-css-extract-plugin
export default {"tag":"XE_1V","cardView":"rXcM_","info":"yAsSD","image":"fVIOf"};